import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { defaultTo, path } from 'ramda';

import { apiUpdateCEU, apiGetCEU, apiApproveCEU, apiRejectCEU } from '../../../../../api/ceu';

import CEU from '../../../CEUs/Individual/CEU';
import ApproveCEUModal from '../../../../../components/Modal/ApproveCEUModal';
import RejectCEUModal from '../../../../../components/Modal/RejectCEUModal';
import { apiGetCertifications } from '../../../../../api/user';

class Review extends Component {
  state = {
    ceu: null,
    certifications: [],
    loaded: false,
    showApproveModal: false,
    showRejectModal: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedCEUId = match.params.id;

    apiGetCEU(selectedCEUId)
      .then((resp) => {
        this.setState({ ceu: resp.data });
        return path(['userId'], resp.data);
      })
      .then((userId) => (userId ? apiGetCertifications(userId) : { data: [] }))
      .then((resp) => this.setState({ certifications: resp.data, loaded: true }));
  }

  render() {
    if (!this.state.loaded) return <noscript />;
    const { ceu, certifications, showApproveModal, showRejectModal } = this.state;

    return (
      <Fragment>
        <CEU
          admin
          ceu={ceu}
          userCertifications={certifications}
          submit={apiUpdateCEU}
          finish={(resp) => this.setState({ ceu: resp.data })}
          approve={() => this.setState({ showApproveModal: true })}
          reject={() => this.setState({ showRejectModal: true })}
          {...this.props}
        />
        <ApproveCEUModal
          show={showApproveModal}
          onHide={(newCEU) => this.setState({ showApproveModal: false, ceu: defaultTo(ceu, newCEU) })}
          ceu={ceu}
          approve={apiApproveCEU}
        />
        <RejectCEUModal
          show={showRejectModal}
          onHide={(newCEU) => this.setState({ showRejectModal: false, ceu: defaultTo(ceu, newCEU) })}
          ceu={ceu}
          reject={apiRejectCEU}
        />
      </Fragment>
    );
  }
}

export default withRouter(Review);
